import { type HttpClient } from '@/application/interfaces/http-client';

export type ActivateCashbackPayload = {
  activationCode: string;
  points: number;
};

export const activateCashback =
  (httpClient: HttpClient.Instance) =>
  async (
    payload: ActivateCashbackPayload,
    options?: HttpClient.BaseOptions
  ): Promise<unknown> => {
    return httpClient.put('/api/v3/carts/activate-cashback', {
      body: payload,
      ...options,
    });
  };
